var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-title"},[_c('el-col',{attrs:{"span":7}},[_vm._t("default")],2),_c('el-col',{attrs:{"span":17}},[_c('div',{staticClass:"card-title-background"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }